import React, {useMemo} from 'react';
import {unstable_HistoryRouter as HistoryRouter} from 'react-router-dom';
import {createBrowserHistory} from 'history';
import theme from "./theme";
import type {History} from '@remix-run/router';
import ApplicationViews from "./views";
import {ApplicationToast, BizkeytechDialogs, BizkeytechReduxStore, BizkeyTechTheme, EnvService} from "../@bizkeytech";
import {Experimental_CssVarsProvider as CssVarsProvider,} from '@mui/material/styles';
import {CssBaseline, responsiveFontSizes} from "@mui/material";
import {toast} from "react-toastify";
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import {Provider as ReduxProvider} from 'react-redux';
import UIUtils from "./utils";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {StaticContentProvider} from "./hooks/use-static-content";
import StaticContent from "../static-content";
import {HelmetProvider} from "react-helmet-async";
import SEO from "./components/seo";

const Application = () => {
    const history = useMemo(() => createBrowserHistory() as unknown as History, [])
    const combinedTheme = useMemo(() => responsiveFontSizes(BizkeyTechTheme.combineTheme(theme)), []);

    return (
        <HelmetProvider>
            <StaticContentProvider value={StaticContent}>
                {/*@ts-ignore*/}
                <CssVarsProvider theme={combinedTheme} defaultMode={'light'}>
                    <CssBaseline enableColorScheme/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <HistoryRouter basename={EnvService.PublicUrl} history={history}>
                            <ReduxProvider store={BizkeytechReduxStore}>
                                <BizkeytechDialogs/>
                            </ReduxProvider>
                            <SEO/>
                            <ApplicationViews/>
                            <ApplicationToast
                                containerId={UIUtils.ToastContainerIDs.default}
                                position={toast.POSITION.BOTTOM_CENTER}
                            />
                        </HistoryRouter>
                    </LocalizationProvider>
                </CssVarsProvider>
            </StaticContentProvider>
        </HelmetProvider>
    );
}

export default Application;
